import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { classNames } from '../utils';

export interface Breadcrumb {
  name: string;
  href: string;
  onClick?: () => void;
  current?: boolean;
}

interface Props {
  breadcrumbs?: Breadcrumb[];
}

export default function Breadcrumbs({ breadcrumbs }: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  const finalBreadcrumbs = useMemo(() => {
    if (breadcrumbs) return breadcrumbs;

    return location.pathname
      .split('?')[0]
      .split('/')
      .map((part, index, all) => {
        if (!part) return null;
        return {
          name: part,
          href: all.slice(0, index + 1).join('/'),
          current: index + 1 === all.length,
        };
      })
      .filter((x) => !!x) as Breadcrumb[];
  }, [breadcrumbs, location]);

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        {/* <li>
          <div>
            <a href="#" className="text-gray-400 hover:text-gray-500">
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </a>
          </div>
        </li> */}
        {finalBreadcrumbs.map((breadcrumb, i) => (
          <li key={breadcrumb.name}>
            <div className="flex items-center">
              {i > 0 && (
                <svg
                  className="h-5 w-5 flex-shrink-0 text-gray-300"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                </svg>
              )}
              <span
                onClick={() => {
                  navigate(breadcrumb.href);
                  breadcrumb.onClick?.();
                }}
                className={classNames(
                  'cursor-pointer text-sm font-medium text-gray-500 hover:text-gray-700',
                  i > 0 ? 'ml-2' : '',
                )}
                aria-current={breadcrumb.current ? 'page' : undefined}
              >
                {breadcrumb.name}
              </span>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
